import { singleton } from "tsyringe";
import { ManagementClient } from "../../lib/management-api.client";
import { ITenantInvitePageResult } from "../tenants/types";
import { IInviteId } from "./types";

@singleton()
export class InviteService {
  public constructor(private readonly http: ManagementClient) {}

  public async acceptInvite(id: string) {
    const { data } = await this.http.put<IInviteId>(
      `/api/v1/invites/${id}/_accept`
    );
    return data;
  }

  public async declineInvite(id: string) {
    const { data } = await this.http.put<IInviteId>(
      `/api/v1/invites/${id}/_decline`
    );
    return data;
  }

  public async getInvites(continuationToken?: string) {
    const { data, headers } = await this.http.get<ITenantInvitePageResult>(
      "/api/v1/invites/pending-list",
      {
        headers: {
          "x-continuation-token": continuationToken
        }
      }
    );
    return {
      viewPage: data,
      continuationToken: headers["x-continuation-token"] as string
    };
  }
}
